// assets/src/js/modules/sliders.js
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

export default function initSliders() {
  // Hero slider
  const bannerElement = document.querySelector(".page_banner_carousel_wrapper");
  if (bannerElement) {
    const page_banner_with_caro = new Swiper(".page_banner_carousel_wrapper", {
      loop: true,
      spaceBetween: 16,
      pagination: {
        el: ".banner_carousel_pagination",
        clickable: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  }

  // Kitchen spaces carousel
  const kitchenElement = document.querySelector(
    ".kitchen_spaces_carousel_wrapper"
  );
  if (kitchenElement) {
    const kitchen_spaces_carousel = new Swiper(
      ".kitchen_spaces_carousel_wrapper",
      {
        loop: true,
        spaceBetween: 24,
        slidesPerView: 1.2,
        navigation: {
          nextEl: ".kitchen_spaces_carousel_nav-next",
          prevEl: ".kitchen_spaces_carousel_nav-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 1.4,
          },
          1024: {
            slidesPerView: 3.4,
          },
        },
      }
    );
  }

  // Blog Filter Carousel
  const blog_filter_slider = document.querySelector(".blog_filter_slider");
  if (blog_filter_slider) {
    const blog_filter_caro = new Swiper(".blog_filter_slider", {
      spaceBetween: 8,
      slidesPerView: "auto",
      auto: true,
      breakpoints: {
        768: {
          spaceBetween: 16,
        },
      },
    });
  }

  // Incubator stories carousel
  const incubatorElement = document.querySelector(
    ".incubator_stories_carousel_wrapper"
  );
  if (incubatorElement) {
    const incubator_stories_carousel = new Swiper(
      ".incubator_stories_carousel_wrapper",
      {
        loop: false,
        spaceBetween: 16,
        slidesPerView: 1.2,
        navigation: {
          nextEl: ".incubator_stories_carousel_nav-next",
          prevEl: ".incubator_stories_carousel_nav-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 2.1,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 4.1,
          },
        },
      }
    );
  }

  // Image carousel with null check
  const imageCarouselElement = document.querySelector(".image_carousel");
  if (imageCarouselElement) {
    const shouldAutoplay = imageCarouselElement.dataset.autoplay === "true";
    const shouldLoop = imageCarouselElement.dataset.loop === "true";

    const swiperConfig = {
      spaceBetween: 16,
      freeMode: true,
      slidesPerView: 1.2,
      navigation: {
        nextEl: ".image_navigation-next",
        prevEl: ".image_navigation-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2.1,
        },
        1024: {
          slidesPerView: 3.4,
        },
      },
    };

    swiperConfig.loop = shouldLoop;

    if (shouldAutoplay && shouldLoop) {
      swiperConfig.speed = 5000;
      swiperConfig.autoplay = {
        delay: 0,
        disableOnInteraction: false,
      };
    } else if (shouldAutoplay) {
      swiperConfig.autoplay = {
        delay: 3000,
        disableOnInteraction: false,
      };
    }

    const image_carousel = new Swiper(".image_carousel", swiperConfig);
  }

  // Initialize events slider for mobile only
  let eventsSwiper; // Declare the variable

  function initEventsSwiper() {
    const eventsElement = document.querySelector(".events_wrapper");
    if (!eventsElement) return; // Exit if element doesn't exist

    if (window.innerWidth < 768) {
      // Mobile view - Initialize Swiper if not already initialized
      if (!eventsSwiper) {
        eventsSwiper = new Swiper(".events_wrapper", {
          slidesPerView: 1.2,
          spaceBetween: 20,
          centeredSlides: false,
        });
      }
    } else {
      // Desktop view - Destroy Swiper if it's initialized
      if (eventsSwiper) {
        eventsSwiper.destroy();
        eventsSwiper = undefined;
      }
    }
  }

  // Programme Structure
  // Initialize programmes slider for mobile/tablet only
  let programmesSwiper; // Declare the variable

  function initProgrammesSwiper() {
    const programmesElement = document.querySelector(".programmes_wrapper");
    if (!programmesElement) return; // Exit if element doesn't exist

    if (window.innerWidth < 1024) {
      // Mobile/tablet view - Initialize Swiper if not already initialized
      if (!programmesSwiper) {
        programmesSwiper = new Swiper(".programmes_wrapper", {
          slidesPerView: 1.2,
          spaceBetween: 16,
          centeredSlides: false,
          breakpoints: {
            768: {
              slidesPerView: 1.4,
            },
          },
        });
      }
    } else {
      // Desktop view - Destroy Swiper if it's initialized
      if (programmesSwiper) {
        programmesSwiper.destroy();
        programmesSwiper = undefined;
      }
    }
  }

  // Team Slider
  // Initialize team slider for mobile only
  let teamSwiper; // Declare the variable

  function initTeamSwiper() {
    const teamElement = document.querySelector(".team_slider");
    if (!teamElement) return; // Exit if element doesn't exist

    if (window.innerWidth < 1025) {
      // Mobile view - Initialize Swiper if not already initialized
      if (!teamSwiper) {
        teamSwiper = new Swiper(".team_slider", {
          slidesPerView: 1.4,
          spaceBetween: 16,
          centeredSlides: false,
        });
      }
    } else {
      // Desktop view - Destroy Swiper if it's initialized
      if (teamSwiper) {
        teamSwiper.destroy();
        teamSwiper = undefined;
      }
    }
  }

  // Run on initial load
  initEventsSwiper();
  initProgrammesSwiper();
  initTeamSwiper();

  // Handle window resize
  window.addEventListener("resize", function () {
    initEventsSwiper();
    initProgrammesSwiper();
    initTeamSwiper();
  });
}
